import { SortDirection, v2_parcelSearchParameters, v2_sortBy } from '@lanterds/types';

export const DEFAULT_SORT_DIRECTION = SortDirection.DESCENDING;
export const DEFAULT_SORT_ORDER: v2_sortBy = 'possessionDateLocal';
export const DEFAULTS_PARAMS: v2_parcelSearchParameters = {
    sortDirection: DEFAULT_SORT_DIRECTION,
    sortBy: DEFAULT_SORT_ORDER,
};
